import urls from './urls';
import axios, { AxiosResponse } from 'axios';
import { addParamsToQueryString } from '../functions/utils';
import { IParamsRequest, IParamsUpperCase } from 'redhotpie-shared-lib/interfaces/IAction';
import { IApiResponse } from 'redhotpie-shared-lib/interfaces/IApiResponse';

class DateFinderApi {
  static getDetailDateFinder(params: IParamsRequest): Promise<IApiResponse> {
    const url = urls.GET_LIST_DATE_FINDER.replace('{ID}', `${params?.id || '-99'}`);
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postFilterDateFinder(params: IParamsRequest): Promise<IApiResponse> {
    const url = urls.POST_FILTER_DATE_FINDER;
    return axios.post(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postCreateDateFinder(params: IParamsRequest): Promise<IApiResponse> {
    const url = urls.POST_CREATE_DATE_FINDER;
    return axios.post(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getMyDateFinder(params: IParamsUpperCase | null): Promise<IApiResponse> {
    return axios.get(addParamsToQueryString(urls.GET_MY_DATE_FINDER, params), {
      baseURL: urls.BASE_RHPURL,
      headers: { isAnonymous: false },
    });
  }

  static getDateFinderInterests(id: string | number, params: IParamsUpperCase | null): Promise<IApiResponse> {
    const url = addParamsToQueryString(urls.GET_MY_DATE_FINDER_INTERESTS.replace('{ID}', `${id}`), params);
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static patchDeleteDateFinder(listId: number[]): Promise<IApiResponse> {
    const url = urls.DELETE_DATE_FINDER;
    const body = { ListID: listId };
    return axios.patch(url, body, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postCreateDateFinderInterest(id: string): Promise<IApiResponse> {
    const url = urls.POST_CREATE_DATE_FINDER_INTEREST.replace('{id}', id);
    return axios.post(url, null, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postCreateDateFinderUnInterest(id: string): Promise<IApiResponse> {
    const url = urls.POST_CREATE_DATE_FINDER_UNINTEREST.replace('{id}', id);
    return axios.post(url, null, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getDateFinderDescriptions(): Promise<IApiResponse> {
    return axios.get(urls.GET_DATE_FINDER_DESCRIPTIONS, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getDateFinderMeetingTypes(): Promise<IApiResponse> {
    return axios.get(urls.GET_DATE_FINDER_MEET_TYPE, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static patchDeleteUserInterested(params: { idMyDate: string; ListID: string[]; Action: string }): Promise<IApiResponse> {
    const url = urls.PATCH_DATE_FINDER_INTEREST.replace('{ID}', params.idMyDate);
    const body = {
      ListID: params.ListID,
      Action: params.Action,
    };
    return axios.patch(url, body, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static editDateFinder(params: IParamsRequest): Promise<IApiResponse> {
    const url = urls.EDIT_DATE_FINDER.replace('{ID}', `${params.id || '-99'}`);
    const body = {
      ID: params.id,
      Dates: params.dates,
      MeetingTypes: params.meetingTypes,
      SeekingTypes: params.seekingTypes,
      AgeMin: params.ageMin,
      AgeMax: params.ageMax,
      Comment: params.comment,
      GoogleMapPlaceID: params.googleMapPlaceID,
      CanHost: params.canHost,
    };
    return axios.patch(url, body, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static deleteAllInterest(params: IParamsRequest): Promise<IApiResponse> {
    const url = urls.DELETE_DATE_FINDER_ALL_INTERESTS.replace('{ID}', `${params.id || '-99'}`);
    return axios.delete(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }
}

export default DateFinderApi;
